<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.4853 2.46073C17.2205 2.19547 16.7909 2.19502 16.5261 2.4596L8.38765 10.5765L5.45133 7.38742C5.1976 7.112 4.76863 7.09414 4.49276 7.34783C4.2171 7.60155 4.19945 8.03074 4.45317 8.3064L7.86776 12.0147C7.99281 12.1506 8.16782 12.2296 8.35235 12.2334C8.35731 12.2336 8.36209 12.2336 8.36684 12.2336C8.54617 12.2336 8.71868 12.1624 8.84577 12.0357L17.484 3.42018C17.7494 3.15563 17.7499 2.72598 17.4853 2.46073Z" class="icon-fill"/>
    <path d="M17.3216 8.32159C16.9469 8.32159 16.6432 8.62527 16.6432 9C16.6432 13.2146 13.2146 16.6432 9 16.6432C4.78561 16.6432 1.35679 13.2146 1.35679 9C1.35679 4.78561 4.78561 1.35679 9 1.35679C9.3747 1.35679 9.67841 1.05311 9.67841 0.67841C9.67841 0.30368 9.3747 0 9 0C4.03734 0 0 4.03734 0 9C0 13.9624 4.03734 18 9 18C13.9624 18 18 13.9624 18 9C18 8.6253 17.6963 8.32159 17.3216 8.32159Z" class="icon-fill"/>
  </svg>
</template>

<script>
export default {
  name: 'checkout'
}
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}
</style>